module.exports = __webpack_public_path__ + "img/20_99.f859aea7.png";